export default {
    methods: {
        randomInteger(id) {
            let hash = Math.random().toString(36).replace('0.', '');

            return `${id}-${hash}`;
        }
    }
}